module.exports = __webpack_public_path__ + "img/heart-red.04574747.svg";